export default __webpack_public_path__ + "static/profile-pic-be6f4e0f623f0130b23fa547b6a2b686.jpg";